export const REQUEST = 'Admin/News/REQUEST';
export const SUCCESS = 'Admin/News/SUCCESS';
export const ERROR = 'Admin/News/ERROR';

export const SET = 'Admin/News/SET';
export const DELETED = 'Admin/News/DELETED';
export const ADDED = 'Admin/News/ADDED';
export const UPDATED = 'Admin/News/UPDATED';
